import * as React from 'react';
import { Wizard } from '@common/components/wizard/_components/wizard.component';
import { PropertyInfo } from './property-info/property-info.container';
import { CustomerInfo } from './customer-info/customer-info.container';
import { AffiliatesInfo } from './affiliates-info/affiliates-info.container';
import { Summary } from './summary/summary.container';

import { CoverageStep } from './coverage/coverage-step.container';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { PriceAdjustmentsStep } from './coverage/price-adjustments-step.container';
import { RouteComponentProps } from 'react-router';
import * as qs from 'query-string';
import { ContractHostedPayment } from './contract-payment/_components/contract-payment-hosted-container';

interface ContractProperties extends RouteComponentProps<{ id: string }> {
  readonly resetContract: (clearPropertyInfo: boolean) => Promise<any>;
  readonly togglePreventReset: () => void;
  readonly loadContractInfo: (contractId: string) => void;
  readonly history: any;
  readonly location: any;
  readonly preventReset: boolean | undefined;
}

export class ContractWithHostedCheckout extends React.Component<ContractProperties> {
  componentDidMount() {
    const props = this.props;
    var cloneTag: string | null = '';
    if (this.props.location && this.props.location.search) {
      const queryParams: any = qs.parse(this.props.location.search);
      cloneTag = queryParams.clone;
    }

    if (!props.preventReset) {
      props.resetContract(true).then(() => {
        if (cloneTag) {
          props.loadContractInfo(cloneTag);
        }
      });
    } else if (cloneTag) {
      props.loadContractInfo(cloneTag);
    }
  }

  componentWillUnmount() {
    this.props.togglePreventReset();
  }
  render() {
    const id = this.props.location && this.props.location.state && this.props.location.state.id;
    const cancelRoute = id
      ? getRoute(RouteDefinitions.contract.Details, {
          id: +id
        })
      : RouteDefinitions.dashboard;
    const steps = [
      { name: 'Property Info', component: PropertyInfo },
      { name: 'Coverage', component: CoverageStep },
      { name: 'Customer Info', component: CustomerInfo },
      { name: 'Affiliates Info', component: AffiliatesInfo },
      { name: 'Price Adjustments', component: PriceAdjustmentsStep },
      { name: 'Review', component: Summary },
      { name: 'Payment', component: ContractHostedPayment }
    ];

    return (
      <>
        <Wizard steps={steps} isQuoteOrContractFlow={true} cancelRoute={cancelRoute} />
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-with-hosted-checkout.tsx